<script setup lang="ts">
import type { IProps } from './BSNumbers.types'

defineProps<IProps>()
</script>

<template>
  <div class="BS-Numbers">
    <div class="BS-Numbers__container">
      <div class="BS-Numbers__header">
        <UiHeader
          v-if="title"
          :header="title"
          position="center"
          header-size="h5"
          header-size-tablet="h5"
          header-size-mobile="h5"
        />
      </div>

      <div class="BS-Numbers__boxContainer">
        <div
          v-for="item in numbers"
          :key="item.header"
          class="BS-Numbers__box"
        >
          <h4 class="BS-Numbers__boxHeader">
            {{ item.header }}
          </h4>

          <p class="BS-Numbers__boxDescription">
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.BS-Numbers {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: auto;
  padding-top: 4rem;
  padding-bottom: 4rem;

  &__container {
    display: flex;
    flex-direction: column;
    max-width: 88.8rem;
    width: 100%;
  }

  &__header {
    margin-bottom: 2.4rem;
  }

  &__boxContainer {
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(1, 1fr);
    gap: 6.4rem;
    width: 100%;
    margin-top: 2.4rem;
  }

  &__box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    width: 100%;
    margin: 0 auto;
  }

  &__boxHeader {
    @include h3;
    color: $purple-400;
    white-space: nowrap;
  }

  &__boxDescription {
    @include body-2-medium;
    width: 70%;
    margin: 0 auto;
    color: $text-400;
    font-size: 1.9rem;
    text-align: center;
  }

  @include atXS {
    &__header {
      margin-bottom: 3rem;
    }

    &__boxContainer {
      grid-template-columns: repeat(2, 1fr);
      gap: 4.8rem;
    }

    &__boxDescription {
      width: 100%;
    }

    &__box {
      flex-direction: column;
      gap: 1.8rem;
      max-width: 240px;
      text-align: center;
    }
  }

  @include atM {
    padding-top: 6rem;
    padding-bottom: 6rem;

    &__boxContainer {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
